export default __webpack_public_path__ + "703a035c2c76797a79dbbd9a6a54c258.png";